import { Backdrop, Button, Card, CardContent, CircularProgress, Link, Typography } from "@mui/material"
import { useAuthContext } from "context/AuthContext"
import { useMediaContext } from "context/MediaContext"
import { Price } from "model/Product"
import { User } from "model/User"
import { useEffect, useState } from "react"

import { db } from "../firebase"
import * as userRepository from 'repository/UserRepository'
import * as productRepository from 'repository/ProductRepository'
import { addDoc, collection, doc, onSnapshot } from "firebase/firestore"
import { useNavigate } from "react-router-dom"

export function Subscription() {
  const [isLoading, setIsLoading] = useState(false)
  const {isPc} = useMediaContext()
  const { auth } = useAuthContext()
  const navigate = useNavigate()
  
  const [user, setUser] = useState<User | null>(null)
  useEffect(() => {
    if (!auth) return
    userRepository.findFromCache(auth.uid).then(it => setUser(it))
  }, [auth])

  const [price, setPrice] = useState<Price | null>(null)
  useEffect(() => {
    if (!user) return
    productRepository.findFromServer().then(it => {
      setPrice(it.prices[0])
    })
  }, [user])

  async function handleRegister() {
    setIsLoading(true)
    const checkoutSession = {
      automatic_tax: true,
      tax_id_collection: true,
      collect_shipping_address: true,
      allow_promotion_codes: true,
      line_items: [{
        price: price!.id!,
        quantity: 1
      }],
      success_url: `${window.location.origin}/`,
      cancel_url: `${window.location.origin}/subscription`,
      metadata: {
        key: 'value',
      },
    }
    const docRef = await addDoc(collection(doc(collection(db, 'customer'), user!.uuid), 'checkout_sessions'), checkoutSession)
    onSnapshot(docRef, snap => {
      const data = snap.data()!
      if (data.error) {
        setIsLoading(false)
        alert(`An error occured: ${data.error.message}`);
        document.querySelectorAll('button').forEach((b) => (b.disabled = false));
      }
      if (data.url) {
        setIsLoading(false)
        window.location.assign(data.url);
      }
    })
  }

  if (!price) {
    return (
      <></>
    )
  }
  return (
    <>
      <Card
        variant='outlined'
        sx={{
          pt: isPc ? 1 : 0,
          px: isPc ? 5 : 0,
        }}
      >
        <CardContent>
          <Typography>サブスクリプション特典（月額{price.unit_amount}円）</Typography>
          <Typography variant='body2' color='text.secondary' sx={{mt: 0.5}}>
            ■「アナリティクス」ページの機能を開放
          </Typography>
          <Typography variant='body2' color='text.secondary' sx={{mt: 0.5}}>
            ■ 実験的な機能の先行（または専用）開放
          </Typography>
          <Typography variant='body2' color='text.secondary' sx={{mt: 0.5}}>
            ■『Rating for MasterDuel』のサービス継続可能性向上
          </Typography>
          <Button
            fullWidth
            variant='outlined'
            onClick={handleRegister}
            disabled={!user || user.is_subscriber}
            sx={{mt: 3}}
          >
            登録する
          </Button>
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{mt: 0.5}}
          >
            ※ 支払い情報登録のため外部サイトに遷移します。
          </Typography>
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{mt: 0.5}}
          >
            ※ 登録前に<Link onClick={() => navigate('/commerce')}>特定商取引法に基づく表記</Link>をご覧ください。
          </Typography>
        </CardContent>
      </Card>
      <Backdrop open={isLoading}>
        <CircularProgress />
      </Backdrop>
    </>
  )
}